var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortotikes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "64px",
    height: "64px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.9,295.5l-17.6,5L356,148.9c-0.5-1.9-1.8-3.5-3.6-4.5c-1.7-1-3.8-1.2-5.7-0.7l-74,21.1c0,0,0,0,0,0l-42.3,12.1 c0,0,0,0,0,0l-66.8,19l-17.7-62.1c-0.6-2.1-2.1-3.8-4-4.7l-45.6-21.3c-3.8-1.8-8.2-0.1-10,3.6c-1.8,3.8-0.1,8.2,3.6,10l42.5,19.9 l18.8,65.9c0,0,0,0,0,0.1L186.4,331c-6.8,3.5-12.4,8.9-16.2,15.7c-5.1,9.1-6.3,19.7-3.4,29.7c4.8,16.7,20.2,28.4,37.6,28.4 c3.6,0,7.2-0.5,10.7-1.5c10-2.9,18.4-9.5,23.4-18.6c4.1-7.4,5.7-15.8,4.6-24.1L396,317.1c0,0,0.1,0,0.1,0L421,310 c4-1.1,6.3-5.3,5.2-9.3C425,296.7,420.8,294.4,416.9,295.5z M279.8,217.1L268,213c-3-1.1-6.3-0.1-8.3,2.4l-7.8,9.7l-10.2-35.8 l27.9-7.9L279.8,217.1z M225.4,377.5c-3.1,5.6-8.3,9.7-14.4,11.4c-2.2,0.6-4.4,0.9-6.6,0.9c-10.7,0-20.2-7.2-23.1-17.5 c-1.8-6.2-1-12.7,2.1-18.3c3.1-5.6,8.3-9.7,14.4-11.4c2.2-0.6,4.4-0.9,6.6-0.9c10.7,0,20.2,7.2,23.1,17.5 C229.3,365.4,228.5,371.9,225.4,377.5z M238.3,346.4c-6.8-12-19.7-19.7-33.9-19.7c-1.2,0-2.3,0.1-3.5,0.2l-33.2-116.5l59.6-17 l14.2,49.7c0.8,2.7,3,4.7,5.7,5.3c0.5,0.1,1,0.1,1.5,0.1c2.2,0,4.4-1,5.8-2.8l13.6-16.9l20.4,7.2c0.8,0.3,1.7,0.4,2.6,0.4 c4.1,0,7.5-3.4,7.5-7.5c0-0.9-0.2-1.8-0.5-2.6l-14-49.2l59.6-17l41.2,144.4L238.3,346.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortotikes);
export default __webpack_public_path__ + "static/media/fortotikes.6485c347f3a9a51bc3f43c8dac3336f3.svg";
export { ForwardRef as ReactComponent };